var React = require('react');

function EntityNumericRange (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"image/entity-type/number","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","fontFamily":"RobotoCondensed-Regular, Roboto Condensed","fontSize":"22","fontStyle":"condensed","fontWeight":"normal","letterSpacing":"-0.141935483"},React.createElement("text",{"id":"1-2-3-4","fill":"#333333"},[React.createElement("tspan",{"x":"14","y":"22","key":0},"1 2"),React.createElement("tspan",{"x":"14","y":"47","key":1},"3 4")])));
}

EntityNumericRange.defaultProps = {"width":"54px","height":"54px","viewBox":"0 0 54 54","version":"1.1"};

module.exports = EntityNumericRange;

EntityNumericRange.default = EntityNumericRange;
